import { createMuiTheme } from "@material-ui/core/styles";
export default function (
  state = {
    userTheme: createMuiTheme({ typography: { useNextVariants: true } }),
  },
  action
) {
  switch (action.type) {
    case "EDIT_THEME":
      return Object.assign({}, state, {
        userTheme: createMuiTheme(action.theme),
      });
    default:
      return state;
  }
}
